// Only run in testing environment
export default defineNuxtPlugin(async () => {
  if (useRuntimeConfig().public.useMsw) {
    try {
      const { worker } = await import('../e2e/_mock/msw/browser')
      await worker.start()
    } catch (error) {
      // Service workers may be blocked in tests that use page.route() instead
      console.warn('[MSW] Service worker registration failed:', error)
    }
  }
})

